
import Modal from "@SharedVueComponents/Modal/Modal.vue";

export default {
	components: {
		Modal,
	},
	props: {
		src: {
			type: String,
			required: true,
		},
		label: {
			type: String,
			required: true,
		},
		caption: {
			type: String,
			required: true,
		},
		infoText: {
			type: String,
			required: true,
		},
	},
	data() {
		return {
			modalActive: false,
		};
	},
};
